xplenty.service('utils', [
  '$window',
  function ($window) {
    const utils = {};

    utils.createScript = function (src, callback) {
      const scriptTag = $window.document.createElement('script');
      scriptTag.type = 'text/javascript';
      scriptTag.async = true;
      scriptTag.src = src;

      scriptTag.onreadystatechange = function () {
        if (this.readyState === 'complete') {
          callback();
        }
      };

      scriptTag.onload = callback;

      const s = $window.document.getElementsByTagName('head')[0];

      s.appendChild(scriptTag);
    };

    return utils;
  },
]);
